"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEngine = void 0;
const BoardManager_1 = require("./BoardManager");
// Deterministic event counter — instance-level for reproducibility
class GameEngine {
    constructor() {
        this.currentTick = 0;
        this.eventCounter = 0;
        this.manager = new BoardManager_1.BoardManager();
    }
    // === Board management ===
    createBoard(boardId, width = 10, height = 10) {
        return this.manager.createBoard(boardId, width, height);
    }
    getBoard(boardId) {
        return this.manager.getBoard(boardId);
    }
    getBoardIds() {
        return this.manager.getBoardIds();
    }
    // === Event recording ===
    recordEvent(event) {
        this.manager.recordEvent(event);
    }
    // Convenience: create and record a typed event
    emit(boardId, type, payload, playerId = '') {
        const event = {
            id: `evt-${this.currentTick}-${this.eventCounter++}`,
            tick: this.currentTick,
            boardId,
            type,
            payload,
            playerId,
        };
        this.recordEvent(event);
        return event;
    }
    // === Tick advancement ===
    advanceOneTick() {
        this.currentTick += 1;
        this.manager.tickAll();
    }
    advanceToTick(targetTick) {
        while (this.currentTick < targetTick) {
            this.advanceOneTick();
        }
    }
    get tick() {
        return this.currentTick;
    }
    // === Rollback ===
    rollbackToTick(targetTick) {
        this.manager.rollbackToTick(targetTick);
        this.currentTick = targetTick;
    }
    // === Cross-board events ===
    queueCrossBoardEvent(cbe) {
        this.manager.queueCrossBoardEvent(cbe);
    }
    // === Snapshots ===
    getBoardState(boardId) {
        const board = this.manager.getBoard(boardId);
        return board === null || board === void 0 ? void 0 : board.getSnapshot();
    }
    getAllBoardStates() {
        return this.manager.getAllSnapshots();
    }
    // === Event log ===
    getEvents() {
        return this.manager.getEvents();
    }
    getEventsForBoard(boardId) {
        return this.manager.getEventsForBoard(boardId);
    }
    getEventsUpToTick(tick) {
        return this.manager.getEventsUpToTick(tick);
    }
}
exports.GameEngine = GameEngine;



//////////////////
// WEBPACK FOOTER
// ../engine/dist/GameEngine.js
// module id = dIbW
// module chunks = 0